/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import favicon from '../images/favicon.svg';
import HeadScripts from './HeadScripts';

function SEO({
  description,
  lang = 'en',
  meta = [],
  title,
  ogTitle,
  ogDescription = '',
  externalCanonicalUrl,
  noFollow,
  ogImageUrl,
  ogImageAlt,
  slug,
  skipQualified = false,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  title = title === 'Fullstory' ? 'Fullstory' : `${title} | ${site.siteMetadata.title}`;
  const metaDescription = description || site.siteMetadata.description;
  const url = `https://www.fullstory.com${slug}`;

  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      <meta name={'title'} content={title} />
      <meta name={'og:title'} content={ogTitle || title} />
      <meta name={'description'} content={metaDescription} />
      <meta name={'og:image'} content={'https:' + ogImageUrl} />
      <meta name={'og:image:alt'} content={ogImageAlt} />
      <meta name={'og:description'} content={ogDescription || metaDescription} />
      <meta name={'og:type'} content={'website'} />
      <meta name={'og:url'} content={url} />
      <meta name={'twitter:card'} content={'summary'} />
      <meta name={'twitter:creator'} content={site.siteMetadata.author} />
      <meta name={'twitter:title'} content={title} />
      <meta name={'twitter:description'} content={metaDescription} />
      <meta name={'twitter:image:alt'} content={ogImageAlt} />
      <meta name={'google-site-verification'} content={'AGOAEpXO_N6ksAlBxnDA74szOdGW8mIKiD754eXLYHI'} />
      {noFollow && <meta name={'robots'} content={'noindex, nofollow'} />}
      <link rel="icon" href={favicon} />
      {!externalCanonicalUrl && <link rel="canonical" href={url} />}
      {externalCanonicalUrl && <link rel={'canonical'} href={externalCanonicalUrl} />}
      <HeadScripts skipQualified={skipQualified} />
    </>
  );
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
